module.exports = __webpack_public_path__ + "img/2700_CT_2022_Title.a8921eb1.png";